import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomProductReferencesComponent} from './custom-product-references.component';
import {CmsConfig, ConfigModule, UrlModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {CustomAddToCartModule} from '../../../cart/custom-add-to-cart/custom-add-to-cart.module';
import {CustomStarRatingModule} from '../../../../shared/components/custom-star-raiting/custom-star-rating.module';
import {CustomProductItemModule} from "../../../../../../custom/cms-components/content/custom-product-item/custom-product-item.module";
import { CustomCarouselModule } from '../../../../shared/components/custom-carousel/custom-carousel.module';


@NgModule({
  declarations: [CustomProductReferencesComponent],
  exports: [CustomProductReferencesComponent],
  imports: [
    CommonModule,
    CustomStarRatingModule,
    CustomAddToCartModule,
    CustomProductItemModule,
    CustomCarouselModule, MediaModule, RouterModule, UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductReferencesComponent: {
          component: CustomProductReferencesComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomProductReferencesModule {
}
